// extracted by mini-css-extract-plugin
module.exports = {"notFound":"style_notFound__1981X","notFoundMsg":"style_notFoundMsg__tWwAn"};